import { uniqueId } from 'lodash-es';

import config from '@/config';
import { env } from '@/env';

export function composeSignInUrl(redirectToHome?: boolean) {
    if (!config.googleOAuth.clientId) {
        throw new Error('Google client ID is not set');
    }

    const url = new URL(config.googleOAuth.origin);
    const redirectUrl = new URL(config.googleOAuth.redirectUrl, window.location.href);

    url.searchParams.set('client_id', config.googleOAuth.clientId);
    url.searchParams.set('redirect_uri', redirectUrl.toString());
    url.searchParams.set(
        'state',
        encodeURIComponent(JSON.stringify({ url: redirectToHome ? config.routes.secrets : window.location.pathname })),
    );
    url.searchParams.set('prompt', 'consent');
    url.searchParams.set('scope', 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email');

    if (env.VITE_DEMO) {
        url.searchParams.set('response_type', 'id_token');
        url.searchParams.set('nonce', uniqueId());
        url.searchParams.set('access_type', 'online');
    } else {
        url.searchParams.set('response_type', 'code');
        url.searchParams.set('access_type', 'offline');
    }

    return url.toString();
}
